<script setup>
defineProps({
  modelValue: {
    type: [String, Number],
    default: '',
  },
  options: {
    type: Array,
    required: true,
    validator: value =>
      value.every(option => 'value' in option && 'label' in option),
  },
});

const emit = defineEmits(['update:modelValue']);
</script>

<template>
  <div class="flex flex-wrap gap-1 p-1 rounded-lg bg-n-alpha-black2 w-fit">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="px-2.5 py-1 text-xs font-medium rounded-md transition-colors"
      :class="
        modelValue === option.value
          ? 'bg-n-alpha-3 text-n-slate-12'
          : 'text-n-slate-11 hover:text-n-slate-12'
      "
      @click="emit('update:modelValue', option.value)"
    >
      {{ option.label }}
    </button>
  </div>
</template>
